import Controller from '@ember/controller';
import { type Registry as Services, service } from '@ember/service';
import type HotelReservationManagerRoute from 'lumen/routes/hotel/reservation-manager';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelReservationManagerController extends Controller {
  declare model: ModelFrom<HotelReservationManagerRoute>;

  @service declare access: Services['access'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isManualRedirectFlow() {
    return this.access.user.hasMultipleSubscriptions;
  }
}
